import 'v-infinite-scroll/dist/v-infinite-scroll.css'
import Vue from 'vue'
import InfiniteScroll from 'v-infinite-scroll'

Vue.use(InfiniteScroll)
